import { Injectable } from '@angular/core';

/**
 * Audioのid定義用
 */
export const AudioIds = {
  ReservationAlert: "reservationAlert",
  CancellationAlert: "cancellationAlert",
  DeadNotifyAlert: "deadNotifyAlert"
};
export type AudioIds = typeof AudioIds[keyof typeof AudioIds];

@Injectable()
export class AudioService {
  private audios : { [key: string]: HTMLAudioElement };
  private isPreloaded : boolean = false;

  constructor() {
    this.audios = {}
    // AudioのIDとファイルの関連付け
    this.audios[AudioIds.ReservationAlert] = new Audio('assets/audio/chime_clickbell_trio.mp3');
    this.audios[AudioIds.CancellationAlert] = new Audio('assets/audio/chime_clickbell_step_down.wav');
    this.audios[AudioIds.DeadNotifyAlert] = new Audio('assets/audio/chord_soft_mid_down.mp3');
  }

  /**
   * 全てのaudioをpreloadする
   */
  public preloadAll(): void {
    if (this.isPreloaded) {
      return;
    }
    for (const key in this.audios) {
      const audio = this.audios[key];
      audio.load();
    }
    this.isPreloaded = true;
  }

  /**
   *
   * @param audioId 再生したいAudioのid
   */
  public play(audioId: AudioIds): void {
    const audio = this.audios[audioId];
    if (!audio) {
      return;
    }
    audio.play();
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/audio-service.ts